export const conflictingSources: string[] = [
  'One video explains how to shake a cocktail.',
  'A forum thread covers classic specs.',
  'A blog post explains how gin is made.',
  'Your old notes cover bar service.',
]

export const symptoms: string[] = [
  'And when you need material for technique, classic recipes, spirits, garnishing or lesson planning...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next class arrives.'

export const needsList: string[] = [
  'You need a clear visual of the tool, the glass or the technique.',
  'You need the drink broken down step by step.',
  'You need drills and practice builds that actually engage your students.',
  'You need ❌/✅ comparisons that correct common mistakes.',
  'And you need a way to see who is really ready to work behind a real bar.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s class?',
  'How do I explain when to shake and when to stir so it finally clicks?',
  'How do I teach the classic specs without a boring list of recipes?',
  'How do I correct a pour or a shake that keeps going wrong?',
  'Which drills fit this group of students?',
  'How do I correct technique without discouraging anyone?',
  'Where do I find visual material for spirits, garnishing and bar operations?',
  'How can I plan better classes without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding classes and practice sessions from scratch every week.',
  'Hours searching scattered videos, forums and notes.',
  'Explaining technique, balance and spirits with words alone.',
  'Students memorizing recipes without understanding why a drink works.',
  'No visual material for technique, garnish and service drills.',
  'Repeating the same corrections every class.',
  'Assessing students without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next class will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT MISTAKES.',
  'HOW TO STRUCTURE THE CLASS.',
  'HOW TO ASSESS PROGRESS.',
]
